/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2023-08-28 16:14:44
 * @LastEditors: Please set LastEditors
 */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from '../messages';
import { Row, Col, Button, message, Tooltip } from 'sup-ui';
import { useDispatch, useSelector } from 'react-redux';
import { envManage } from '../../store/actions';
import { useNavigate } from 'react-router-dom';
import { reducerStates } from 'root/store/types';
import moment from 'moment';
import LinkStatusTag from '../LinkStatusTag';
import 'moment-timezone';

import {
  getHostBasicDataApi,
  getHostTimeApi,
  postSyncTimeApi,
  deleteNodeApi,
  getHostResourceApi,
} from 'root/services/disk';
import { IPlatformTimeType } from 'root/components/EditSysTime/types';
// import { updatePlatformTimeApi } from 'root/services/netWork';

import LinkSet from '../LinkSet';
import NetworkCard from 'root/components/NetworkCard';
import DiskPartition from '../DiskPartition';
import CommonModal from 'root/components/CommonModal';

import styles from './index.less';

const Detail = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { singleNodeId, cluster, acitveKey, isSuposInstalled } = useSelector((state: reducerStates) => state.envManage);
  const [serverData, setServerData] = useState<any>({});
  const [resourceData, setResourceData] = useState<any>({});

  const [sysTime, setSysTime] = useState<IPlatformTimeType>({
    timezone: '',
    isAuto: 0,
    systemTime: '',
    ntpIP: [],
  });
  let loopTimer: any = null;

  useEffect(() => {
    // 只有当前tab等于主机检测才调接口
    if (acitveKey === '2' && singleNodeId) {
      getServerData();
    }
    return () => {
      clearTimeout(loopTimer);
    };
  }, [acitveKey, singleNodeId]);

  // 获取主机信息
  const getServerData = () => {
    getHostBasicDataApi({ clientIds: [singleNodeId as string] }).then((res) => {
      const { data = {} } = res;
      setServerData(data);
      if (loopTimer === null) {
        loopGetData();
      }
    });
    getHostResourceApi({ clientIds: [singleNodeId as string] }).then((res) => {
      const { data = {} } = res;
      setResourceData(data);
    });

    getSysTime();
  };

  // 获取系统时间
  const getSysTime = () => {
    getHostTimeApi({ clientIds: [singleNodeId as string] }).then((res) => {
      const {
        data: { timezone, auto, systemTime, ntpIP },
      } = res;
      setSysTime({
        timezone,
        isAuto: auto ? 1 : 0,
        ntpIP,
        systemTime,
      });
    });
  };

  // 论询
  const loopGetData = () => {
    loopTimer = setTimeout(() => {
      clearTimeout(loopTimer);
      getServerData();
      loopTimer = null;
    }, 1000 * 30);
  };

  // 同步系统时间
  const handleSyncTime = () => {
    postSyncTimeApi({ clientIds: [singleNodeId as string] }).then(() => {
      message.success(intl.formatMessage(messages.syncTimeSuccess));
      getSysTime();
    });
  };

  // 删除节点
  const handleDelete = () => {
    CommonModal.confirm({
      onOk: () => {
        deleteNodeApi([singleNodeId as string]).then(() => {
          message.success(intl.formatMessage(messages.deleteSuccess));
          dispatch(
            envManage.changeEnvStatus({
              singleNodeId: '',
            }),
          );
          sessionStorage.removeItem('singleNodeId');
        });
      },
      title: intl.formatMessage(messages.deleteConfirm),
    });
  };

  return (
    <div className={styles.detail}>
      <LinkStatusTag data={{ ...serverData, ...resourceData }} />
      <div className={styles.detail_host}>
        <LinkSet getServerData={getServerData} serverData={{ ...serverData, ...resourceData }} />
        <div className={styles.sysTimeBox}>
          {intl.formatMessage(messages.systemTime)}
          <div className={styles.sysTime}>
            <Row>
              <Col span={5}>
                <span>{intl.formatMessage(messages.timeZone)}</span>
                <div>{sysTime?.timezone || '---'} </div>
              </Col>
              <Col span={5}>
                <span>{intl.formatMessage(messages.timeAndDate)}</span>
                <div>
                  {sysTime?.systemTime
                    ? moment(sysTime.systemTime).tz(sysTime.timezone).format('YYYY[年]MM[月]DD[日] HH:mm')
                    : '---'}
                </div>
              </Col>
            </Row>
            <div onClick={handleSyncTime} style={{ cursor: 'pointer' }}>
              {intl.formatMessage(messages.syncTime)}
            </div>
          </div>
        </div>
        <div className={styles.networkManage}>
          <NetworkCard singleNodeId={singleNodeId} />
        </div>
      </div>
      <div className={styles.detail_disk}>
        <div className={styles.diskTitle}>{intl.formatMessage(messages.diskData)}</div>
        <DiskPartition />
      </div>
      <div className={styles.operateBtn}>
        {!cluster && (
          <Tooltip className={styles.title_name} title={intl.formatMessage(messages.changeEnvTip)}>
            <Button
              style={{ width: 280 }}
              className={styles.changeBtn}
              onClick={() => navigate('/inductive')}
              type="primary"
              disabled={serverData?.hasSupOs}
            >
              {intl.formatMessage(messages.changeEnvType)}
            </Button>
          </Tooltip>
        )}

        {isSuposInstalled ? (
          <Tooltip className={styles.title_name} title={intl.formatMessage(messages.deleteNodeTip)}>
            <Button disabled={serverData?.hasSupOs} onClick={handleDelete}>
              {intl.formatMessage(messages.delete)}
            </Button>
          </Tooltip>
        ) : (
          <Button disabled={serverData?.hasSupOs} onClick={handleDelete}>
            {intl.formatMessage(messages.delete)}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Detail;
